var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"home"}},[_c('Header',{ref:"header"}),_c('Whoweare'),_c('WhyPay'),_c('div',{staticStyle:{"overflow":"hidden"}},[_c('BancanteWorld'),_c('Form')],1),_c('ShareSection'),_c('Testimonials'),_c('FooterSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }